<template>
  <div>
    <default-layout-component hide-left-sidebar hide-right-sidebar :fillMobile="true" />
  </div>
</template>

<script>
import DefaultLayoutComponent from '@/components/DefaultLayoutComponent/'
export default {
  components: {
    DefaultLayoutComponent
  }
}
</script>
